













import { Component, Vue } from 'vue-property-decorator'
import Main from '@/components/Main.vue'
import Intro from '@/components/Intro.vue'
import Vision from '@/components/Vision.vue'
import Newsletter from '@/components/Newsletter.vue'
import AboutUs from '@/components/AboutUs.vue'
import Projects from '@/components/Projects.vue'
import Events from '@/components/Events.vue'
import Network from '@/components/Network.vue'

@Component({
    components: {
        Main,
        Intro,
        Vision,
        Newsletter,
        AboutUs,
        Projects,
        Events,
        Network,
    },
})
export default class Home extends Vue {}
